import './assets/css/normalize.css';
import './assets/fonts/fonts.css';
import './assets/css/style.css';
import './assets/app/result-block/result-block.css';
import './assets/app/history-block/history-block.css';
import React from 'react';
import { render } from 'react-dom';
import { showTaps } from './app/taps';
import { detectBackend } from './common/backend';

showTaps();
// the backend is settled before the app loads: its modules read it as they load
detectBackend().then(() => import('./App')).then(({ App }) => render(<App />, document.getElementById('app')));
